module.exports = __webpack_public_path__ + "static/media/studio-slide12.6321fa9e.png";